import { render, staticRenderFns } from "./HourGlass.vue?vue&type=template&id=d872edc8&scoped=true"
import script from "./HourGlass.vue?vue&type=script&lang=js"
export * from "./HourGlass.vue?vue&type=script&lang=js"
import style0 from "./HourGlass.vue?vue&type=style&index=0&id=d872edc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d872edc8",
  null
  
)

export default component.exports